<div class="purchase_item flex items-center space-between">
  <div class="flex items-center">
    <stxt-svg-icon
      *ngIf="purchaseType"
      [iconConfig]="purchaseSvg"
      class="purchase_item__svg"
    ></stxt-svg-icon>
    <div class="purchase_info">
      <p
        *ngIf="purchaseType"
        class="purchase_info__heading"
        [innerHTML]="getTransactionInfo(ETransactionInfoType.DISPLAY)"
      ></p>
      <ng-container
        [ngTemplateOutlet]="getTransactionInfo(ETransactionInfoType.TEMPLATE)"
      ></ng-container>
    </div>
  </div>

  <stxt-svg-icon
    *ngIf="purchaseType === EPurchaseType.SUBSCRIPTION || purchaseType === EPurchaseType.TOKENS"
    [iconConfig]="rightNavSvg"
    (click)="openTransactionInfo(purchase)"
    (keydown.enter)="openTransactionInfo(purchase)"
    class="purchase_item__svg"
    tabindex="-1"
  ></stxt-svg-icon>

  <div
    *ngIf="
      purchaseType === EPurchaseType.GENERATE_IMAGE ||
      purchaseType === EPurchaseType.MEDIA ||
      purchaseType === EPurchaseType.VOICE_CALL
    "
    class="flex flex-row"
  >
    <img src="/assets/icons/token-badge-grey.svg" alt="token" />
    <p class="token-amount">{{ getAbsoluteValue(purchase.amount_tokens || purchase.amount) }} -</p>
  </div>

  <div *ngIf="purchaseType === EPurchaseType.TOKENS_TOPUP">
    <div class="flex flex-row">
      <img src="/assets/icons/token-badge.svg" alt="token" />
      <p class="token-amount_topup">{{ purchase.amount_tokens || purchase.amount }} +</p>
    </div>
  </div>
</div>

<ng-template #tokensPurchase>
  <p>
    <span
      [ngClass]="{
        paid: purchase.state === EPurchaseState.Paid || !purchase.state,
        canceled: purchase.state === EPurchaseState.Canceled
      }"
      class="purchase_item__status"
    ></span>
    {{ purchase.state ? (purchase.state | titlecase) : 'Paid' }}
    <span *ngIf="purchase.state === EPurchaseState.Canceled">payment</span>
    {{ purchase.metadata.item_price / 100 | currency }}
    total on {{ purchase.created_at | date: 'MM/dd/yyyy' }}
  </p>
</ng-template>

<ng-template #tokensTopupPurchase>
  <p>Added on {{ purchase.created_at | date: 'MM/dd/yyyy' }}</p>
</ng-template>

<ng-template #voiceCallPurchase>
  <p>Spent on {{ purchase.created_at | date: 'MM/dd/yyyy' }}</p>
</ng-template>

<ng-template #imagePurchase>
  <p>Unlocked on {{ purchase.created_at | date: 'MM/dd/yyyy' }}</p>
</ng-template>

<ng-template #subscriptionPurchase>
  <p>
    <span
      [ngClass]="{
        paid: purchase.state === EPurchaseState.Paid || !purchase.state,
        canceled: purchase.state === EPurchaseState.Canceled
      }"
      class="purchase_item__status"
    ></span>
    {{ purchase.state ? (purchase.state | titlecase) : 'Paid' }}
    <span *ngIf="purchase.state === EPurchaseState.Canceled">payment</span>
    {{ getAbsoluteValue(purchase.amount) / 100 | currency }}
    total on {{ purchase.created_at | date: 'MM/dd/yyyy' }}
  </p>
</ng-template>

<ng-template #generateImagePurchase>
  <p>
    {{ purchase.total | currency }}
    Generated on {{ purchase.created_at | date: 'MM/dd/yyyy' }}
  </p>
</ng-template>
